
        module.exports = {
          src: __webpack_public_path__ + "static/media/face.d4e28553f0ca3c6d9c22d108527fa00b.webp",
          placeholder: "data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAABQBACdASoUABMAPzmMuVavKSUjqA1R4CcJQBhQAbEftjmDYCVtPLFysZ0AAPzbvRIlhD0gMNamnKpLno7yGcBtom+6Vw8PHgYeBx1b60HpWpMCTH21+o0C0lYA1KT0i5nMmhFpNqE0OxwSd4A1KgAxQAg7bAF2M/kiMRX30r5NtIFmbvDcPmnMRJUIM7Mn89gAAA==",
          width: 175,
          height: 169
        };
      